import { TimeEntry } from '../types/timeTracking'

export const timeEntries: TimeEntry[] = [
  {
    id: 'time-1',
    company_id: 'wf',
    project_id: 'proj-1',
    resource_name: 'Sergey Kleymuk',
    hours: 4.5,
    notes: 'Initial homepage design and wireframes',
    date: new Date('2024-01-15'),
    created_at: new Date('2024-01-15'),
  },
  {
    id: 'time-2',
    company_id: 'wf',
    project_id: 'proj-1',
    resource_name: 'Sasha Oleksandr',
    hours: 6.25,
    notes: 'Frontend implementation of homepage',
    date: new Date('2024-01-16'),
    created_at: new Date('2024-01-16'),
  },
  {
    id: 'time-3',
    company_id: 'wf',
    project_id: 'proj-15',
    resource_name: 'Dmitry Syrov',
    hours: 8.0,
    notes: 'AWS infrastructure setup and Lambda configuration',
    date: new Date('2024-01-25'),
    created_at: new Date('2024-01-25'),
  },
  {
    id: 'time-4',
    company_id: 'wf',
    project_id: 'proj-15',
    resource_name: 'David Nssien',
    hours: 5.75,
    notes: 'Database schema design and migration scripts',
    date: new Date('2024-01-25'),
    created_at: new Date('2024-01-25'),
  },
  {
    id: 'time-5',
    company_id: 'wf',
    project_id: 'proj-3',
    resource_name: 'Sasha Oleksandr',
    hours: 3.5,
    notes: 'Service area pages development',
    date: new Date('2024-01-20'),
    created_at: new Date('2024-01-20'),
  },
]
